import React, { Component, Fragment } from 'react';
import {
  CloseCircleFilled,
  CloseOutlined,
  DeleteOutlined,
  SearchOutlined,
} from '@ant-design/icons';
import { Select, Input, Popover, Tooltip } from "antd";
import { strDelimited } from '../../../../services/helper/split';
import _ from 'lodash';

class InterposerModel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      portList: []
    }
  }

  componentDidMount() {
    if (this.props.onRef) {
      this.props.onRef(this);
    }
    this.initData()
    document.addEventListener('mousedown', this.handleClickOutside, true);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside, true);
  }

  componentDidUpdate(prevProps) {
    const { selectFileList, pairs = [] } = this.props;
    if (!_.isEqual(selectFileList, prevProps.selectFileList)) {
      const fileInfo = selectFileList[0]
      this.setState({
        selectFile: {
          libraryId: fileInfo ? fileInfo.libraryId : '',
          fileName: fileInfo ? fileInfo.fileName : '',
          modelKey: fileInfo ? fileInfo.modelKey : '',
          subckt: fileInfo ? fileInfo.subckt : '',
          nodes: fileInfo ? fileInfo.nodes : [],
          type: fileInfo ? fileInfo.type : ''
        }
      })
    }
    if (!_.isEqual(pairs, prevProps.pairs)) {
      this.initPortList()
    }
  }


  handleClickOutside = (e) => {
    const { target } = e;
    const PopoverRoot = document.getElementsByClassName('spice-node-select-Popover')[0];
    const selectRoot = document.getElementsByClassName('nodes-list-file-dropdown')[0];

    if (!PopoverRoot) {
      return;
    }

    if (!PopoverRoot || (PopoverRoot && !PopoverRoot.contains(target) && (!selectRoot || !selectRoot.contains(target)))) {
      this.closeNodesSelection();
    }
  }

  initData = () => {
    const { selectFileList } = this.props
    if (selectFileList.length) {
      const fileInfo = selectFileList[0]
      this.setState({
        selectFile: {
          libraryId: fileInfo ? fileInfo.libraryId : '',
          fileName: fileInfo ? fileInfo.fileName : '',
          modelKey: fileInfo ? fileInfo.modelKey : '',
          subckt: fileInfo ? fileInfo.subckt : '',
          nodes: fileInfo ? fileInfo.nodes : [],
          type: fileInfo ? fileInfo.type : ''
        }
      })
    }
    this.initPortList()
  }

  initPortList = () => {
    const { portList, pairs } = this.props
    const pairsMap = new Map(pairs.map(pair => {
      const key = `${pair.designId}-${pair.powerNet}-${pair.port}`;
      return [key, pair];
    }));
    const _portList = portList.map(({ leftPorts = [], rightPorts = [], ...info }) => ({
      ...info,
      leftPorts: leftPorts.map(leftPort => ({
        ...leftPort,
        ...(pairsMap.get(`${leftPort.designId}-${leftPort.powerNet}-${leftPort.port}`) || {})
      })),
      rightPorts: rightPorts.map(rightPort => ({
        ...rightPort,
        ...(pairsMap.get(`${rightPort.designId}-${rightPort.powerNet}-${rightPort.port}`) || {})
      }))
    }));
    this.setState({
      portList: _portList
    })
  }

  closeNodesSelection = () => {
    this.setState({
      editNode: null,
      editType: null,
      searchValue: null,
      editComp: null
    })
  }

  selectNodesFile = (keyObj) => {
    const { selectFileList } = this.props;
    if (!keyObj) {
      this.setState({
        selectFile: {}
      })
      return;
    }
    const [libraryId, modelKey, subckt] = strDelimited(keyObj.key, "::");
    if (!libraryId || !modelKey) {
      this.setState({
        selectFile: {}
      })
      return;
    }
    const fileInfo = selectFileList.find(item => item.libraryId === libraryId);
    this.setState({
      selectFile: {
        libraryId,
        fileName: fileInfo ? fileInfo.fileName : '',
        modelKey,
        subckt,
        nodes: fileInfo ? fileInfo.nodes : [],
        type: fileInfo ? fileInfo.type : ''
      }
    })
  }

  openSelectNode = ({ port, value, type, currentItem }) => {
    const { selectFile } = this.state
    const { selectFileList } = this.props
    const editDesignId = currentItem.designId
    const editPowerNet = currentItem.powerNet
    const editPort = port
    const editNode = `${editDesignId}-${editPowerNet}-${editPort}`
    const libraryId = currentItem.libraryId || ""
    const modelKey = currentItem.modelKey || ""
    const subckt = currentItem.subckt || ""
    let _selectFile = selectFile || {}
    if (libraryId) {
      const file = selectFileList.find(item => item.libraryId === libraryId && item.modelKey === modelKey)
      _selectFile = {
        libraryId,
        fileName: file ? file.fileName : "",
        subckt,
        modelKey,
        type: file ? file.type : "",
        nodes: file ? file.nodes : []
      };
    }
    this.setState({
      editNode,
      searchValue: value,
      selectFile: _selectFile
    })
  }

  stopPropagation = (e) => {
    e.stopPropagation();
  }

  selectPinNode = ({ node, selectFile, type, currentItem }) => {
    const { portList } = this.state
    const { pairs } = this.props
    let _portList = JSON.parse(JSON.stringify(portList))
    let _pairs = JSON.parse(JSON.stringify(pairs))
    const subckt = selectFile.subckt, libraryId = selectFile.libraryId, modelKey = selectFile.modelKey, fileName = selectFile.fileName
    const index = _portList.findIndex(item => {
      const currentPorts = type === 'leftPort' ? item.leftPorts : item.rightPorts
      return currentPorts.find(currentPort => currentPort.designId === currentItem.designId && currentPort.port === currentItem.port)
    })
    if (index < 0) {
      return;
    }
    const portIndex = _portList[index][`${type}s`].findIndex(currentPort => currentPort.designId === currentItem.designId && currentPort.powerNet === currentItem.powerNet && currentPort.port === currentItem.port)
    if (portIndex > -1) {
      _portList[index][`${type}s`][portIndex].node = node
      _portList[index][`${type}s`][portIndex].fileName = fileName
      _portList[index][`${type}s`][portIndex].libraryId = libraryId
      _portList[index][`${type}s`][portIndex].modelKey = modelKey
      _portList[index][`${type}s`][portIndex].subckt = subckt ? subckt : ""
    }
    const pairIndex = _pairs.findIndex(item => item.port === currentItem.port && item.powerNet === currentItem.powerNet && item.designId === currentItem.designId)
    if (pairIndex > -1) {
      _pairs[pairIndex].node = node
      _pairs[pairIndex].subckt = subckt ? subckt : ""
      _pairs[pairIndex].libraryId = libraryId
      _pairs[pairIndex].modelKey = modelKey
    }
    this.props.updatePairs(_pairs)
    this.setState({
      portList: _portList
    })
    this.closeNodesSelection();
  }

  deleteSelectNode = (e, type, currentItem) => {
    e && e.stopPropagation()
    const { portList } = this.state
    const { pairs } = this.props
    let _portList = JSON.parse(JSON.stringify(portList))
    let _pairs = JSON.parse(JSON.stringify(pairs))
    const index = _portList.findIndex(item => {
      const currentPorts = type === 'leftPort' ? item.leftPorts : item.rightPorts
      return currentPorts.find(currentPort => currentPort.designId === currentItem.designId && currentPort.powerNet === currentItem.powerNet && currentPort.port === currentItem.port)
    })
    if (index < 0) {
      return;
    }
    const portIndex = _portList[index][`${type}s`].findIndex(currentPort => currentPort.designId === currentItem.designId && currentPort.port === currentItem.port)
    if (portIndex > -1) {
      _portList[index][`${type}s`][portIndex].node = ""
      _portList[index][`${type}s`][portIndex].fileName = ""
      _portList[index][`${type}s`][portIndex].libraryId = ""
      _portList[index][`${type}s`][portIndex].modelKey = ""
      _portList[index][`${type}s`][portIndex].subckt = ""
    }
    const pairIndex = _pairs.findIndex(item => item.port === currentItem.port && item.powerNet === currentItem.powerNet && item.designId === currentItem.designId)
    if (pairIndex > -1) {
      _pairs[pairIndex].node = ""
      _pairs[pairIndex].subckt = ""
      _pairs[pairIndex].libraryId = ""
      _pairs[pairIndex].modelKey = ""
    }
    this.props.updatePairs(_pairs)
    this.setState({
      portList: _portList
    })
  }

  isSameNode = (port, selectFile, node) => {
    return (
      port.libraryId === selectFile.libraryId &&
      port.subckt === selectFile.subckt &&
      port.node === node
    );
  }

  getDisplayPortList = ({ currentItem, searchValue, selectFile }) => {
    const { portList } = this.state;
    const { nodes = [] } = selectFile;
    const nodeList = nodes.map(node => {
      let select = false;
      let currentSelect = false;
      if (this.isSameNode(currentItem, selectFile, node)) {
        currentSelect = true;
      }
      select = portList.some(({ leftPorts, rightPorts }) => {
        const leftPort = leftPorts.find(port => port.node === node && port.designId === currentItem.designId)
        const rightPort = rightPorts.find(port => port.node === node && port.designId === currentItem.designId)
        return (leftPort && leftPort !== currentItem && this.isSameNode(leftPort, selectFile, node)) ||
          (rightPort && rightPort !== currentItem && this.isSameNode(rightPort, selectFile, node))
      });
      return { node, select, currentSelect };
    });

    const current = nodeList.filter(item => item.currentSelect);
    const matched = nodeList.filter(item => item.node.includes(searchValue) && !item.currentSelect && !item.select);
    const unused = nodeList.filter(item => !item.select && !item.currentSelect && !item.node.includes(searchValue));
    const used = nodeList.filter(item => item.select && !item.currentSelect);

    return [...current, ...matched, ...unused, ...used];
  }

  searchNode = (e) => {
    this.setState({
      searchValue: e.target.value
    })
  }

  cleanPort = () => {
    this.props.resetPairs()
  }

  nodeSelectRender = ({ portName, port, type, currentItem }) => {
    const { searchValue, selectFile = {} } = this.state;
    const { selectFileList } = this.props;
    const nodeList = this.getDisplayPortList({ currentItem, searchValue, selectFile });
    return (
      <div className='nodes-content' style={{ maxHeight: 600, maxWidth: 400 }}>
        <div className='nodes-content-header'>
          <span className='nodes-content-header-span'> {portName ? portName : `Port ${port}`}</span>
        </div>
        <div className='node-content-close' onClick={() => this.closeNodesSelection()}>
          <CloseOutlined className='node-content-close-icon' />
        </div>
        <div className="node-list-body-with-search">
          <div className="node-list-body-search-wrapper">
            <Select
              placeholder={`Select File/Subckt`}
              className='nodes-list-file-select'
              labelInValue
              value={{
                key: selectFile.libraryId ? selectFile.subckt ? `${selectFile.libraryId}::${selectFile.modelKey}::${selectFile.subckt}` : `${selectFile.libraryId}::${selectFile.modelKey}` : "",
                label: selectFile.subckt ? `${selectFile.fileName}::${selectFile.subckt}` : selectFile.fileName || ""
              }}
              popupClassName='nodes-list-file-dropdown'
              popupMatchSelectWidth={false}
              onChange={option => option && this.selectNodesFile({ label: option.label, key: option.value })}
              options={selectFileList.map(item => ({
                value: item.subckt ? `${item.libraryId}::${item.modelKey}::${item.subckt}` : `${item.libraryId}::${item.modelKey}`,
                label: item.subckt ? `${item.fileName}::${item.subckt}` : item.fileName || "",
                title: item.subckt ? `${item.fileName}::${item.subckt}` : item.fileName || "",
                className: "spice-nodes-content-file"
              }))}
            />
            <Input
              placeholder={`Search`}
              allowClear
              suffix={!searchValue ? <SearchOutlined style={{ color: 'rgba(0, 0, 0, .25)' }} /> : null}
              value={searchValue}
              onChange={(e) => this.searchNode(e)}
            />
            <ul className='node-list-ul' style={{ maxHeight: 300 }}>
              {nodeList.map(item =>
                <li
                  key={item.node}
                  title={item.node}
                  className={item.currentSelect ? 'current-pin-selected-node-li' : (item.select ? 'node-li-selected' : '')}
                  onClick={() => !item.select ? this.selectPinNode({ node: item.node, selectFile, type, currentItem }) : null}
                >
                  {item.node}
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    );
  }

  getLeftPinDisplay = ({ item: leftPort, editNode, type }) => {
    const [editDesignId, editPowerNet, editPort] = strDelimited(editNode, '-')
    const { port = '', designId = '', portName = '', powerNet = '' } = leftPort || {}
    const key = `${designId}-${powerNet}-${port}`
    return (
      <div key={key} className='spice-total-pin-box' style={{ width: 254 }}>
        {port ? <Fragment>
          {/* pin_L */}
          <div className='spice-pin-die-value-box' title={portName ? portName : `Port ${port}`}>
            <span className='spice-pin-value-span'>{portName ? portName : `Port ${port}`}</span>
          </div>
          {/* pin L connect port */}
          <div className='spice-pin-die-box'>
            {editNode && editDesignId === designId && editPowerNet === powerNet && editPort === port ? <Popover
              classNames={{ root: 'spice-node-select-Popover' }}
              content={this.nodeSelectRender({
                portName: portName,
                port: port,
                type,
                currentItem: leftPort
              })}
              title=""
              trigger="click"
              open={true}
              placement={"top"}
            >
              <Input
                className='spice-pin-input'
                placeholder={'Node'}
                value={leftPort.node}
                id={port}
                onClick={() => this.openSelectNode({
                  port: port,
                  value: leftPort.node,
                  type,
                  currentItem: leftPort,
                })}
              />
            </Popover> :
              leftPort.node ?
                <Tooltip
                  classNames={{ root: 'aurora-tooltip' }}
                  onClick={(e) => this.stopPropagation(e)}
                  title={<Fragment>{leftPort && leftPort.fileName && <div>FileName:{leftPort.fileName}</div>}<div>Port:{leftPort.node}</div></Fragment>}>
                  <div className='spice-pin-input' id={port} title={leftPort.node}
                    onClick={() => this.openSelectNode({
                      port: port,
                      value: leftPort.node,
                      type,
                      currentItem: leftPort,
                    })}
                  >
                    <span>{leftPort.node}</span>
                    <CloseCircleFilled
                      className='spice-pin-node-delete-icon'
                      onClick={(e) => { this.deleteSelectNode(e, type, leftPort) }}
                    />
                  </div>
                </Tooltip>
                :
                <Input
                  className='spice-pin-input'
                  placeholder={'Node'}
                  value={leftPort.node}
                  id={port}
                  onClick={() => this.openSelectNode({
                    port: port,
                    value: leftPort.node,
                    type,
                    currentItem: leftPort,
                  })}
                />}
          </div>
          <div className='spice-pin-line'></div>
          <div className='spice-pin-circle'></div>
        </Fragment> : null}
      </div>
    )
  }

  getRightPinDisplay = ({ item: rightPort, editNode, type }) => {
    const [editDesignId, editPowerNet, editPort] = strDelimited(editNode, '-')
    const { port = '', designId = '', portName = '', powerNet = '' } = rightPort || {}
    const key = `${designId}-${powerNet}-${port}`
    return (
      <div key={key} className='spice-total-pin-box' style={{ width: 254 }}>
        {port ? <Fragment>
          <div className='spice-pin-circle'></div>
          <div className='spice-pin-line'></div>
          {/* pin R connect port */}
          <div className='spice-pin-box'      >
            {editNode && editDesignId === designId && editPowerNet === powerNet && editPort === port ? <Popover
              classNames={{ root: 'spice-node-select-Popover' }}
              content={this.nodeSelectRender({
                portName: portName,
                port: port,
                type,
                currentItem: rightPort
              })}
              title=""
              trigger="click"
              open={true}
              placement={"top"}
            >
              <Input
                className='spice-pin-input'
                placeholder={'Node'}
                value={rightPort.node}
                id={port}
                onClick={() => this.openSelectNode({
                  port: port,
                  value: rightPort.node,
                  type,
                  currentItem: rightPort,
                })}
              />
            </Popover> :
              rightPort.node ?
                <Tooltip
                  classNames={{ root: 'aurora-tooltip' }}
                  onClick={(e) => this.stopPropagation(e)}
                  title={<Fragment>{rightPort && rightPort.fileName && <div>FileName:{rightPort.fileName}</div>}<div>Port:{rightPort.node}</div></Fragment>}>
                  <div className='spice-pin-input' id={port} title={rightPort.node}
                    onClick={() => this.openSelectNode({
                      port: port,
                      value: rightPort.node,
                      type,
                      currentItem: rightPort,
                    })}
                  >
                    <span>{rightPort.node}</span>
                    <CloseCircleFilled
                      className='spice-pin-node-delete-icon'
                      onClick={(e) => { this.deleteSelectNode(e, type, rightPort) }}
                    />
                  </div>
                </Tooltip>
                :
                <Input
                  className='spice-pin-input'
                  placeholder={'Node'}
                  value={rightPort.node}
                  id={port}
                  onClick={() => this.openSelectNode({
                    port: port,
                    value: rightPort.node,
                    type,
                    currentItem: rightPort,
                  })}
                />
            }
          </div>
          {/* pin R */}
          <div className='spice-pin-value-box' title={portName ? portName : `Port ${port}`}>
            <span className='spice-pin-value-span'>{portName ? portName : `Port ${port}`}</span>
          </div>
        </Fragment> : null}
      </div >
    );
  }

  titleContent = () => {
    const { leftModelTitle, rightModelTitle, overviewReverse } = this.props;
    return <div className="spice-pin-connect-node-title" style={{ paddingLeft: 20 }}>
      <span className={`${overviewReverse ? 'spice-pin-connect-right-title' : 'spice-pin-connect-left-title'}`} style={{ color: '#000000D9' }}>{leftModelTitle}</span>
      <span className={`${overviewReverse ? 'spice-pin-connect-left-title' : 'spice-pin-connect-right-title'}`}>{rightModelTitle}</span>
      <span className='spice-pin-center-title'>Interposer</span>
      <DeleteOutlined
        title="Clean Ports"
        className='cascade-spice-pin-delete'
        onClick={() => this.cleanPort()} />
    </div>
  }

  render() {
    const { editNode, portList } = this.state;
    const { overviewReverse } = this.props
    let className = "spice-pin-connect-node-item";
    const paddingRight = 10;

    const signalSelectDisableClassName = '';
    return (
      <Fragment>
        <div className='spice-netlist-model-content'>

          <div className='spice-connect-content'>
            <ul className='spice-pin-list-ul'>
              {this.titleContent()}
              {portList.map((item, index) => {
                const { leftPorts, rightPorts, net } = item;
                const maxLength = Math.max(leftPorts.length, rightPorts.length)
                return <div className={`${className}`} key={index} style={{ height: 32 * maxLength + 30, paddingRight: 10 }}>
                  <div className='spice-pin-list-li-left'>
                    {(overviewReverse ? rightPorts : leftPorts).map(leftPort => this.getLeftPinDisplay({ item: { ...leftPort, index: item.index }, editNode, type: `${overviewReverse ? 'rightPort' : 'leftPort'}` }))}
                  </div>
                  {/* net box */}
                  <div
                    className={index === 0 ? `spice-box spice-box-top ${signalSelectDisableClassName}` : (index === (portList.length - 1) ? `spice-box spice-box-bottom ${signalSelectDisableClassName}` : `spice-box ${signalSelectDisableClassName}`)}
                  >
                    <span className='spice-box-net-text'>{net}</span>
                  </div>
                  <div className='spice-pin-list-li-right'>
                    {(overviewReverse ? leftPorts : rightPorts).map(rightPort => this.getRightPinDisplay({ item: { ...rightPort, index: item.index }, editNode, type: `${overviewReverse ? 'leftPort' : 'rightPort'}` }))}
                  </div>
                </div>
              })}
            </ul>
          </div>
        </div>
      </Fragment >
    );
  }
}

export default InterposerModel;